module.exports = __webpack_public_path__ + "static/media/ehealth_minor_redemption_banner_mobile.13be4cd9.jpg";